import React, { useEffect, useState } from "react";
import { Button, Form, Col, Row, Modal } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderTitle,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { useDispatch, useSelector } from "react-redux";
import {
  addItem,
  editItem,
  editSequenceItem,
  fetchId,
  fetchIdNoloading,
  removeById,
  selectId,
  selectLoading,
} from "./settingJourneySlice";
import { useHistory, useParams } from "react-router";
import {
  showSuccessDialog,
  showErrorDialog,
  GOOGLE_KEY,
  allDay,
  getValueStatus,
  createChangeHandler,
  CallApi,
  paramsMasterAll,
  setOptionsMaster,
  showDialog,
  useForceUpdate,
  setOptionsSelect,
  hari,
  showDeleteDialog,
} from "../../utility";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import GoogleMapReact from "google-map-react";
import Select from "react-select";
import { selectUser } from "../../modules/Auth/_redux/authRedux";
import CurrencyInput from "react-currency-input-field";
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory from "react-bootstrap-table2-editor";

import {
  sortCaret,
  headerSortingClasses,
  PleaseWaitMessage,
  NoRecordsFoundMessage,
  toAbsoluteUrl,
} from "../../../_metronic/_helpers";
import { fetchCustomer, selectCustomer } from "../customer/customerSlice";
import { fetchUser, selectDataUser } from "../user/userSlice";

import SVG from "react-inlinesvg";

import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import {
  GoogleMap,
  Marker,
  DirectionsRenderer,
  useLoadScript,
} from "@react-google-maps/api";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { fetchSynch, selectDataSynch } from "../company/companySlice";

const libraries = ["places"];
const mapContainerStyle = { width: "100%", height: "600px" };
const center = { lat: -6.2088, lng: 106.8456 };

export const SettingJourneyRoute = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectLoading);
  const user = useSelector(selectUser);
  const dataUser = useSelector(selectDataUser);
  const dataId = useSelector(selectId);
  const dataCustomer = useSelector(selectCustomer);
  const { id } = useParams();
  const forceUpdate = useForceUpdate();
  const { SearchBar } = Search;
  const synch = useSelector(selectDataSynch);

  const [visit, setVisit] = useState("");
  const [customer, setCustomer] = useState("");
  const [sales, setSales] = useState("");
  const [optionsCust, setOptionsCust] = useState([]);
  const [optionsUser, setOptionsUser] = useState([]);
  const [show, setShow] = useState("");

  const [listCustomer, setListCustomer] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [optionsFreq, setOptionsFreq] = useState([]);
  const [frequensi, setFrequensi] = useState("");
  const [kunjungan, setKunjungan] = useState([]);

  const [points, setPoints] = useState([]);
  const [key, hari] = id.split(",");

  const paramsId = {
    user_id: key,
    hari_kunjungan: hari,
  };

  useEffect(() => {
    async function fetchMyAPI() {
      await dispatch(fetchSynch());

      if (id !== undefined) {
        await CallApi(paramsId, fetchId, dispatch);
      }
    }
    fetchMyAPI();
  }, [dispatch]);

  useEffect(() => {
    if (dataId) {
      const initData = dataId.customers.map((item, index) => {
        return {
          ...item,
          no: index + 1,
          name: item.customer_code + "-" + item.customer_store_name,
          id: item.customer_id,
          lat: parseFloat(item.customer_latitude),
          lng: parseFloat(item.customer_longitude),
        };
      });
      setPoints(initData);
    }
  }, [dataId]);

  useEffect(() => {
    if (synch) {
      setOptionsSelect(synch, "Frekuensi Kunjungan", setOptionsFreq);
    }
  }, [synch]);

  const handleSave = async () => {
    const initData = points.map((item, index) => {
      return {
        ...item,
        journey_setting_details: [],
        visit_order: index + 1,
      };
    });
    const params = initData;

    try {
      const response =
        id === undefined
          ? await dispatch(addItem(params))
          : await dispatch(editSequenceItem(params));
      console.log(response, "response");
      if (response.payload.status === 200) {
        await showSuccessDialog(response.payload.message);
        (await id) === undefined
          ? history.goBack()
          : await CallApi(paramsId, fetchIdNoloading, dispatch);
      } else {
        showErrorDialog(response.payload.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
      console.log(error.message);
    }
  };

  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: GOOGLE_KEY,
    libraries,
  });
  const [isGoogleLoaded, setIsGoogleLoaded] = useState(false);
  const [directions, setDirections] = useState(null);

  useEffect(() => {
    if (isLoaded && !loadError) setIsGoogleLoaded(true);
  }, [isLoaded, loadError]);

  useEffect(() => {
    if (!isGoogleLoaded || points.length < 2 || !window.google) return;

    const MAX_WAYPOINTS = 25;
    const totalChunks = Math.ceil((points.length - 2) / MAX_WAYPOINTS);

    let mergedDirections = []; // menampung semua segment hasil API

    const processChunk = (index) => {
      if (index >= totalChunks) {
        // selesai → set ke state kamu
        setDirections(mergedDirections);
        return;
      }

      const start = index * MAX_WAYPOINTS;
      const end = start + MAX_WAYPOINTS;
      const chunk = points.slice(start, end + 1);

      if (chunk.length < 2) {
        processChunk(index + 1);
        return;
      }

      const directionsService = new window.google.maps.DirectionsService();
      directionsService.route(
        {
          origin: { lat: chunk[0].lat, lng: chunk[0].lng },
          destination: {
            lat: chunk[chunk.length - 1].lat,
            lng: chunk[chunk.length - 1].lng,
          },
          waypoints: chunk.slice(1, -1).map((p) => ({
            location: { lat: p.lat, lng: p.lng },
          })),
          travelMode: window.google.maps.TravelMode.DRIVING,
        },
        (result, status) => {
          if (status === "OK") {
            mergedDirections.push(result);
          } else {
            console.error("Route error:", status);
          }

          processChunk(index + 1);
        }
      );
    };

    processChunk(0);
  }, [isGoogleLoaded, points]);

  const directionsCallback = (response) => {
    if (response !== null && response.status === "OK") setDirections(response);
    else console.log("directions response: ", response);
  };

  const [searchTerm, setSearchTerm] = useState(""); // State untuk menyimpan nilai pencarian
  const [searchTermFreq, setSearchTermFreq] = useState(""); // State untuk menyimpan nilai pencarian

  const handleDragStart = (e, index) => {
    e.dataTransfer.setData("index", index);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e, targetIndex) => {
    const sourceIndex = e.dataTransfer.getData("index");
    const newData = [...points];
    const item = newData.splice(sourceIndex, 1)[0];
    newData.splice(targetIndex, 0, item);
    setPoints(newData);
  };

  // Filter points berdasarkan nilai pencarian
  const filteredData = points.filter(
    (item) =>
      item?.name.toLowerCase().includes(searchTerm.toLowerCase()) &&
      (!frequensi || item?.frequen === frequensi)
  );

  const handleDelete = async (item) => {
    console.log(item, "item");
    const id = item.journey_setting_id;

    const params = {
      journey_setting_id: `${item.journey_setting_id}`,
      hari_kunjungan: hari,
    };

    const action = await showDeleteDialog(
      `Are you sure want to delete?<br><strong>${item.customer_code} - ${item.customer_store_name}</strong>`
    );
    if (action.isConfirmed) {
      try {
        const response = await dispatch(removeById(params));
        if (response.payload.status === 200) {
          const action = await showSuccessDialog(response.payload.message);
          await window.location.reload();

          const newData = points.filter((item) => item.id !== id);
          setPoints(newData);
        } else {
          showErrorDialog(response.payload.message);
        }
      } catch (error) {
        console.log(error);
        showErrorDialog("Something went wrong!");
      }
    }
  };

  const handleChangeFrequensi = (e) => {
    console.log(e, "e");
    if (e === null) {
      e = undefined;
      setFrequensi("");
    } else {
      setFrequensi(e.value);
    }
  };

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      <Card>
        <CardHeader>
          <CardHeaderTitle className="card-title">
            {id === undefined
              ? "Visit Order Journey Setting"
              : "Visit Order Journey Setting"}
          </CardHeaderTitle>
          <CardHeaderToolbar>
            <Button
              className="btn btn-secondary mr-3"
              onClick={() => history.goBack()}
            >
              <i className="fa fa-arrow-left"></i>Back
            </Button>
            <Button
              className="btn btn-danger"
              onClick={(e) => {
                handleSave();
              }}
            >
              Save
            </Button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <Form>
            <Form.Group as={Row}>
              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Sales Code</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      disabled
                      value={dataId?.company_sales_code}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Sales Name</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      disabled
                      value={dataId?.company_sales_name}
                    />
                  </Col>
                </Form.Group>
              </Col>
              {/* Right Row */}

              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Hari Kunjungan</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control type="text" disabled value={hari} />
                  </Col>
                </Form.Group>
              </Col>
            </Form.Group>
          </Form>

          <hr />

          <Form>
            <Form.Group as={Row}>
              <Col sm={6}>
                {points.length > 0 && (
                  <div
                    style={{
                      margin: "20px",
                    }}
                  >
                    <Form.Group as={Row}>
                      <Form.Label column sm={4} className="ml-6">
                        <b>Customer</b>
                      </Form.Label>
                      <Col sm={6}>
                        <Form.Control
                          type="text"
                          placeholder="Search..."
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                        />{" "}
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row}>
                      <Form.Label column sm={4} className="ml-6">
                        <b>Frekuensi</b>
                      </Form.Label>
                      <Col sm={6}>
                        <Select
                          options={optionsFreq}
                          value={getValueStatus(frequensi, optionsFreq)}
                          placeholder="Select ..."
                          onChange={handleChangeFrequensi}
                          isClearable={true}
                        />
                      </Col>
                    </Form.Group>

                    <div
                      style={{
                        margin: "20px",
                        maxHeight: "600px",
                        overflowY: "auto",
                      }}
                    >
                      <table
                        style={{
                          width: "100%",
                          borderCollapse: "collapse",
                        }}
                      >
                        <tbody>
                          {filteredData.map((item, index) => (
                            <tr
                              key={item.id}
                              draggable
                              onDragStart={(e) => handleDragStart(e, index)}
                              onDragOver={(e) => handleDragOver(e)}
                              onDrop={(e) => handleDrop(e, index)}
                              style={{
                                padding: "8px",
                                border: "1px solid #ddd",
                              }}
                            >
                              <td
                                style={{
                                  padding: "12px",
                                  border: "1px solid #ddd",
                                }}
                              >
                                <span>
                                  <b>{item.no}</b>
                                </span>
                              </td>
                              <td
                                style={{
                                  padding: "12px",
                                  border: "1px solid #ddd",
                                  display: "flex",
                                  // alignItems: "center",
                                  justifyContent: "space-between", // Tambahkan style untuk menjaga jarak antara item dan ikon delete
                                }}
                              >
                                <span
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                  }}
                                >
                                  <b>{item.customer_code}</b>
                                  <p>{item.customer_store_name}</p>
                                </span>
                                <div>
                                  <span>
                                    <b className="mr-4">{item.frequen_name}</b>
                                  </span>
                                  <div
                                    className="btn btn-icon btn-light btn-hover-danger btn-sm"
                                    onClick={() => handleDelete(item)}
                                  >
                                    <span className="svg-icon svg-icon-md svg-icon-danger">
                                      <SVG
                                        src={toAbsoluteUrl(
                                          "/media/svg/icons/General/Trash.svg"
                                        )}
                                      />
                                    </span>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}
              </Col>
              {/* Right Row */}

              <Col sm={6}>
                {isLoaded ? (
                  <GoogleMap
                    id="autocomplete-demo"
                    mapContainerStyle={mapContainerStyle}
                    zoom={8}
                    center={center}
                  >
                    {/* {points.map((point) => (
                      <Marker
                        key={point.id}
                        position={{ lat: point.lat, lng: point.lng }}
                      />
                    ))} */}
                    {Array.isArray(directions) &&
                      directions.map((dir, i) => (
                        <DirectionsRenderer key={i} directions={dir} />
                      ))}
                  </GoogleMap>
                ) : (
                  <div>Loading...</div>
                )}
              </Col>
            </Form.Group>
          </Form>
        </CardBody>
      </Card>
    </>
  );
};
